import * as React from "react";
import { TooltipCloseIcon as CloseIcon } from "../Tooltip.components";

export interface TooltipCloseIconProps {
  onClick: () => void | Promise<void>;
}

export const TooltipCloseIcon = ({
  onClick,
  ...rest
}: TooltipCloseIconProps): React.ReactElement => (
  <CloseIcon onClick={onClick} aria-label="Close tooltip" {...rest} />
);
